import { Component } from '@angular/core';
import { LoginService } from '../login.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent {
  loader=false
constructor(public service:LoginService,  private toastr:ToastrService,
  public router:Router
){

}
  async Submit(Email: string){
  this.loader=true;
  console.log(Email);
  
  // Here you can make API call to send password reset link to the provided email address.
  await this.service.ForgetPassword(Email).subscribe({
    next: (r:any) => {
      console.log(r)
      this.toastr.success(r.message)
      this.loader=false
      this.router.navigateByUrl("/login")
      // this.router.navigateByUrl(environment.BaseUrl+"login")
    },
    error: e => {
      this.loader=false
      console.log(e)
      if(e.error.message){
        this.toastr.error('Oops!', e.error.message);
      }
      else{
        this.toastr.error('Oops!', "Something went wrong");
      }
    }
  })
 
}
}
